import React, { Fragment } from 'react';
import { Tooltip, Divider } from 'antd';
import { renderIconDashboard } from '../helpers';

const DashboardButton = ({ row, handleClic }) => {
  let { Icon, title } = renderIconDashboard(row);  
  return (
    <Fragment>
        <Divider type='vertical' />
        <div onClick={handleClic}>
            <Tooltip title={title}>
                {Icon}
            </Tooltip>
        </div>
    </Fragment>
  );
};

export default DashboardButton;
